import {
  Plugins,
  EnvTypes,
  type TypeImplementation,
  SiteModules,
} from '@packages/systems/wfdl';
import {TText} from '@packages/systems/wfdl-ast';

export const plugin = ({
  timezone,
  otherValues = {},
  otherDataTypes = {},
  siteModuleDependencies = {},
}: {
  timezone: string;
  otherValues?: {
    [key: string]: EnvTypes.TypedValue;
  };
  otherDataTypes?: {
    [key: string]: TypeImplementation.TypeImplementation;
  };
  siteModuleDependencies?: SiteModules.SiteModuleDependencyMap;
}) =>
  Plugins.PrivilegedPlugin({
    values: {
      timezone: {
        envType: {
          dataType: TText,
          exported: 'hidden',
        },
        value: timezone,
      },
      ...otherValues,
    },
    dataTypes: {
      ...otherDataTypes,
    },
    siteModuleDependencies,
  });
